export default __webpack_public_path__ + "static/media/login_bg1.6a1af34f.png";